/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useId, useMemo } from 'react';
import * as S from './DropDownSelect.styled';
import { CustomInput } from 'components';
import { ClearSearchInput, SearchIcon } from 'assets/icons';

import { useFloating, flip, offset, autoUpdate, autoPlacement } from '@floating-ui/react-dom';

const DropDownSelect = ({
  children,
  placeholder,
  activeElem = null,
  onResetValue = () => {},
  width,
  search = false,
  icon,
  onSearch = () => {},
  searchValue,
  maxHeight = 270,
  error,
  id = '',
  isDynamicChildren = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const name_id = useId();
  const { refs, floatingStyles } = useFloating({
    middleware: [
      autoPlacement({ alignment: 'bottom-start', autoAlignment: false }),
      flip(),
      offset(5),
    ],
    whileElementsMounted: autoUpdate,
  });

  useEffect(() => {
    if (searchValue && !isOpen) setIsOpen(true);
  }, [searchValue]);

  function handleClear(e) {
    e.stopPropagation();
    onResetValue();
  }

  const isDisabled = useMemo(() => {
    if (!isDynamicChildren && (!children || children?.length === 0) && !searchValue) return true;
    if (isDynamicChildren) return false;
  }, [children, searchValue, isDynamicChildren]);

  const isDropdown = () => {
    if (!isDynamicChildren) return children?.length > 0;
    if (isDynamicChildren) return true;
  };

  const myIsOpen = () => {
    if (!isDynamicChildren) return isOpen;
    if (isDynamicChildren && children) {
      return isOpen;
    }
    return false;
  };

  return (
    <>
      {myIsOpen() && <S.Slice onClick={() => setIsOpen(false)} />}
      <S.Container
        width={width}
        isOpen={myIsOpen()}
        onClick={() => setIsOpen(!isOpen)}
        className='Container'
      >
        <S.InputContainer
          ref={refs.setReference}
          isSearchIcon={search && !activeElem}
          isIcon={!!icon}
        >
          <CustomInput
            name={name_id}
            isDropdown={isDropdown()}
            readOnly={search && !activeElem ? false : true}
            onChange={search ? onSearch : () => {}}
            error={error}
            arrowIconIsActive={isOpen && children?.length > 0}
            value={activeElem ? ' ' : searchValue ? searchValue : ''}
            placeholder={!activeElem ? placeholder : ''}
            rightIcon={<ClearSearchInput />}
            rightIconOnClick={handleClear}
            disabled={isDisabled}
            id={id}
            autoComplete={'off'}
          />
          {search && !activeElem && (
            <S.SearchIcon>
              <SearchIcon />
            </S.SearchIcon>
          )}
          {icon && <S.Icon isSearchIcon={search && !activeElem}>{icon}</S.Icon>}
          {activeElem && <S.SelectedItem isIcon={icon}>{activeElem}</S.SelectedItem>}
        </S.InputContainer>
        {isOpen && children && (
          <S.ComponentForScroll
            className='ComponentForScroll'
            isOpen={isOpen}
            ref={refs.setFloating}
            style={{
              width: width,
              maxHeight: maxHeight,
              ...floatingStyles,
            }}
          >
            <S.Ul className='UI' maxHeight={maxHeight}>
              {children}
            </S.Ul>
          </S.ComponentForScroll>
        )}
      </S.Container>
    </>
  );
};

export default DropDownSelect;
